import { jsx as _jsx } from "react/jsx-runtime";
import { EmptyState, Table } from '@dixa/lib-shared-habla';
export const ConversationsTableEmptyRow = () => {
    return (_jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ colSpan: 100 }, { children: _jsx(EmptyState, { title: "No conversations match the criteria", description: "Try changing or resetting filters", size: "large", icon: "url-trigger" }) })) }));
};
